module.exports = __webpack_public_path__ + "img/AC_S4_Calendar.8c565493.jpg";